import React from 'react';
import './styles/footer.scss';
import {
    FaFacebookF,
    FaTwitter,
    FaInstagram,
    FaPinterest,
} from 'react-icons/fa';

import { SiVisa } from 'react-icons/si';
import { FaCcPaypal, FaCcMastercard } from 'react-icons/fa';
function Footer() {
    return (
        <>
            <footer>
                <aside className='footer_aside'>
                    <h2>MENU</h2>
                    <div className='footer-menu-container'>
                        <div className='footer-menu-links'>
                            <p>Shop</p>
                            <p>Features</p>
                            <p>Sales</p>
                            <p>Contacts</p>
                        </div>
                        <div className='footer-menu-links'>
                            <p>Help</p>
                            <p>Shipping</p>
                            <p>Privacy Policy</p>
                            <p>FAQs</p>
                        </div>
                    </div>
                </aside>
                <aside className='footer_aside'>
                    <h2>CONTACTS</h2>
                    <p className='footer-mail'>hello@myhome.com</p>
                    <p className='footer-phone'>+375 29 364-74-69</p>
                </aside>
                <aside className='footer_aside'>
                    <h2>STAY SOCIAL</h2>
                    <div className='footer-icons-container'>
                        <FaTwitter className='footer-icon' />
                        <FaPinterest className='footer-icon' />
                        <FaInstagram className='footer-icon' />
                        <FaFacebookF className='footer-icon' />
                    </div>
                    <p className='footer-icons-info'>
                        We Work All The Holidays
                    </p>
                </aside>
            </footer>

            <summary className='footer-payments'>
                <p>Copyright © All Rights Reserved.</p>
                <div>
                    <FaCcMastercard className='footer-icon' />
                    <SiVisa className='footer-icon' />
                    <FaCcPaypal className='footer-icon' />
                </div>
            </summary>
        </>
    );
}

export default Footer;
